var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Windows Icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 262 255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".windows-cls-1{fill:#f05423;}.windows-cls-2{fill:#84c441;}.windows-cls-3{fill:#2dabe2;}.windows-cls-4{fill:#f9bc15;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "windows-cls-1",
    d: "M125.78,124.64H25.61V24.47H125.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "windows-cls-2",
    d: "M236.39,124.64H136.21V24.47H236.39V124.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "windows-cls-3",
    d: "M125.78,235.29H25.61V135.12H125.78Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "windows-cls-4",
    d: "M236.39,235.29H136.21V135.12H236.39V235.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/Windows.31763d896fecdfaa9b1bfd44f830f178.svg";
export { ForwardRef as ReactComponent };